angular.module('aprima-utils').factory('PatientDashboardHelper',
    ['_',
        function (_) {
            'use strict';

            var getLayout = function(layout, displayColumns){
                var rows = [];
                var currentRow  = {
                    totalColumns : 0,
                    columns: []
                };

                var columnCreation = function(widget){
                    currentRow.columns.push({
                        columnSpan: widget.ColumnSpan,
                        widgets: [widget]
                    });

                    currentRow.totalColumns += widget.ColumnSpan;
                };

                var maxColumnSpan = _(layout).map('ColumnSpan').max();
                if(maxColumnSpan !== Infinity && maxColumnSpan > displayColumns) {
                    throw new Error('Trying to calculate a layout with a greater number of columns (' + maxColumnSpan + ') than the requested number of columns (' + displayColumns + ').');
                }

                for(var i = 0; i < layout.length;){
                    var activeRow = [], span = 0;

                    while(span < displayColumns){
                        if(i < layout.length && span + layout[i].ColumnSpan <= displayColumns){
                            activeRow.push(layout[i]);
                            span += layout[i].ColumnSpan;
                            i++;
                        }
                        else{
                            break;
                        }
                    }

                    if(currentRow.totalColumns === 0){
                        _.forEach(activeRow, columnCreation);
                    }
                    else{
                        var willFit = true;

                        if(activeRow.length === currentRow.columns.length || (i === layout.length && activeRow.length < currentRow.columns.length)){
                            for(var x = 0; x < activeRow.length; x++){
                                if(activeRow[x].ColumnSpan !== currentRow.columns[x].columnSpan){
                                    willFit = false;
                                }
                            }
                        }
                        else{
                            willFit = false;
                        }

                        if(willFit){
                            for(var y = 0; y < activeRow.length; y++){
                                currentRow.columns[y].widgets.push(activeRow[y]);
                            }
                        }
                        else{
                            rows.push(currentRow);

                            currentRow  = {
                                totalColumns : 0,
                                columns: []
                            };

                            _.forEach(activeRow, columnCreation);
                        }
                    }
                }

                rows.push(currentRow);
                return rows;
            };

            return {
                getLayout: getLayout
            };
        }]);
